module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-container"
  }, [_c('ul', _vm._l((_vm.footers), function(footer, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: footer.path
          })
        }
      }
    }, [_c('span', {
      staticClass: "footer-wrapper"
    }, [(footer.isNotificationActive) ? _c('img', {
      staticClass: "__count",
      attrs: {
        "src": _vm.notificationIcon,
        "width": "8"
      }
    }) : _vm._e(), _vm._v(" "), (footer.path === _vm.currentRoute) ? _c('img', {
      attrs: {
        "src": footer.activeIcon,
        "width": "23"
      }
    }) : _c('img', {
      attrs: {
        "src": footer.icon,
        "width": "23"
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c92bd32","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/footer.vue
// module id = 1634
// module chunks = 180